import { render } from "./GroupOrUserSelect.vue?vue&type=template&id=e8b07cf6&scoped=true"
import script from "./GroupOrUserSelect.vue?vue&type=script&lang=js"
export * from "./GroupOrUserSelect.vue?vue&type=script&lang=js"

import "./GroupOrUserSelect.vue?vue&type=style&index=0&id=e8b07cf6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8b07cf6"]])

export default __exports__